import { Chip } from "@mui/material";

interface ObservationMediaPointSpeciesChipProps {
    confidence: number;
    species: string;
    detections: number;
}

export function ObservationMediaPointSpeciesChip({ confidence, species, detections }: ObservationMediaPointSpeciesChipProps) {
    const label = `${species} (${(confidence * 100).toFixed()}%, ${detections}x)`;
    return <Chip key={species} label={label} size="small" />;
}
